// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
const firebaseConfig = {
  apiKey: "AIzaSyDifcjAi-3EJv1qTknjcpuiU5lQdGBrPsM",
  authDomain: "kulturfestival-belegupload.firebaseapp.com",
  projectId: "kulturfestival-belegupload",
  storageBucket: "kulturfestival-belegupload.firebasestorage.app",
  messagingSenderId: "133817746623",
  appId: "1:133817746623:web:3351e796e56e3070ecb20a"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);